// App.tsx
import React from 'react';
// import logo from './logo.svg';
import './App.css';
import {router} from "./constants/routes";
import {RouterProvider} from "react-router-dom";
import { ToastContainer, Zoom } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import 'react-loading-skeleton/dist/skeleton.css'




function App() {
  return (
    <>
    <RouterProvider router={router} />
    <ToastContainer
        limit={1}
        autoClose={3000}
        transition={Zoom}
        pauseOnFocusLoss={false}
        newestOnTop
      />
    </>
  
 
  );
}

export default App;
